export type WarehouseAdminRetourStatus = "open"|"loaded"|"received";

export interface IWarehouseAdminRetourProductData {
    id: number;
    name: string;
    description?: string|null;
}

export interface IWarehouseAdminRetourCoreData {
    id: number;
    product?: number;
    building: string;
    amount: number;
    created?: string|null;
    created_by?: string|null;
    createdBy?: string|null;
    finished?: string|null;
    finished_by?: string|null;
    finishedBy?: string|null;
    received?: string|null;
    received_by?: string|null;
    receivedBy?: string|null;
}

export interface IWarehouseAdminRetourData {
    retour?: IWarehouseAdminRetourCoreData;
    id?: number;
    product_id?: number;
    building?: string;
    amount?: number;
    created?: string|null;
    created_by?: string|null;
    createdBy?: string|null;
    finished?: string|null;
    finished_by?: string|null;
    finishedBy?: string|null;
    received?: string|null;
    received_by?: string|null;
    receivedBy?: string|null;
    status: WarehouseAdminRetourStatus|string;
    product: IWarehouseAdminRetourProductData;
}

export default class WarehouseAdminRetourData {
    public id: number;
    public product_id: number;
    public building: string;
    public amount: number;
    public created: string|null;
    public created_by: string|null;
    public finished: string|null;
    public finished_by: string|null;
    public received: string|null;
    public received_by: string|null;
    public status: WarehouseAdminRetourStatus|string;
    public product: {
        id: number;
        name: string;
        description: string|null;
    };

    constructor(data: IWarehouseAdminRetourData) {
        const retour = data.retour;

        this.id = Number(retour?.id ?? data.id);
        this.product_id = Number(retour?.product ?? data.product_id ?? data.product.id);
        this.building = retour?.building ?? data.building ?? "";
        this.amount = Number(retour?.amount ?? data.amount ?? 0);
        this.created = retour?.created ?? data.created ?? null;
        this.created_by = retour?.created_by ?? retour?.createdBy ?? data.created_by ?? data.createdBy ?? null;
        this.finished = retour?.finished ?? data.finished ?? null;
        this.finished_by = retour?.finished_by ?? retour?.finishedBy ?? data.finished_by ?? data.finishedBy ?? null;
        this.received = retour?.received ?? data.received ?? null;
        this.received_by = retour?.received_by ?? retour?.receivedBy ?? data.received_by ?? data.receivedBy ?? null;
        this.status = data.status;

        this.product = {
            id: Number(data.product.id),
            name: data.product.name,
            description: data.product.description ?? null
        };
    }
}